/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Import_SuccessInputs */



/**
* | output |
* | --- |
* | "Transcript import successful" |
*
* @param {Transcript_Import_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_import_success = /** @type {((inputs?: Transcript_Import_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Import_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de transcription réussie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkriptimport erfolgreich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione della trascrizione riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт стенограммы пройден успешно.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de transcripción exitosa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成绩单导入成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトのインポートに成功しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेख आयात सफल रहा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação da transcrição concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Transcript import successful")
});